/// <reference path="../../../typings/browser.d.ts" />

namespace Application.Controllers {
    'use strict';

    export interface IMultiBlockModalScope extends ng.IScope {
        blocks: {
            srcBlocks: Models.Block[];
            srcConnections: Models.IBlockConnections[];
            dstBlocks: Models.Block[];
            dstConnections: Models.IBlockConnections[];
            selected: {
                name?: string;
                srcBlock: Models.Block;
                srcConnection: Models.IBlockConnections;
                dstBlock: Models.Block;
                dstConnection: Models.IBlockConnections;
            }
        };
        modalClose: () => void;
        modalSave: () => void;
        clear: () => void;
    }

    export class MultiBlockModalController {
        public static templateUrl: string = "decorators/modals/multi-block-modal.html";
        public static id: string = "#id-multi-block-modal";
        public static $name: string = "multiBlockModal";
        public static $inject: string[] = ['$scope', 'close', '$timeout', 'blocks'];

        constructor($scope: IMultiBlockModalScope,
                    close: (response: {name: string, srcConn: number, dstConn: number}) => void,
                    $timeout: ng.ITimeoutService,
                    blocks: Models.Block[]) {

            $timeout(() => {
                window.altair_admin_common_init();
                window.altair_forms_validation();
            }, 500);

            blocks = this.init(blocks, $scope);

            $scope.$watch('blocks.selected.srcBlock', (newVal: Models.Block, oldVal: Models.Block) => {
                // a source has been selected
                if (newVal !== oldVal) {
                    if (newVal) {
                        // populating the source connections
                        if (newVal.blockConnections) {
                            $scope.blocks.srcConnections = newVal.blockConnections.filter((connection: Models.IBlockConnections) => {
                                if ($scope.blocks.selected.dstBlock && $scope.blocks.selected.dstConnection) {
                                    return connection.direction === 'OUTPUT' &&
                                        connection.connectionTypeName === $scope.blocks.selected.dstConnection.connectionTypeName;
                                } else {
                                    return connection.direction === 'OUTPUT';
                                }
                            });
                            $scope.blocks.selected.srcConnection = $scope.blocks.srcConnections[0];
                        }
                        // populating the destination blocks
                        if (!$scope.blocks.selected.dstBlock || $scope.blocks.selected.dstBlock.name === '') {
                            $scope.blocks.dstBlocks = blocks.filter((block: Models.IBlock) => {
                                return block.blockConnections.filter((connection: Models.IBlockConnections) => {
                                        if ($scope.blocks.selected.srcConnection) {
                                            return connection.direction === 'INPUT' &&
                                                connection.connectionTypeName === $scope.blocks.selected.srcConnection.connectionTypeName;
                                        } else {
                                            return connection.direction === 'INPUT';
                                        }
                                    }).length > 0;
                            });
                        }
                    } else {
                        $scope.blocks.srcConnections = [];
                    }
                }
            });

            $scope.$watch('blocks.selected.dstBlock', (newVal: Models.Block, oldVal: Models.Block) => {
                // a destination has been selected
                if (newVal !== oldVal) {
                    if (newVal) {
                        // populating the destination connections
                        if (newVal.blockConnections) {
                            $scope.blocks.dstConnections = newVal.blockConnections.filter((connection: Models.IBlockConnections) => {
                                if ($scope.blocks.selected.srcBlock && $scope.blocks.selected.srcConnection) {
                                    return connection.direction === 'INPUT' &&
                                        connection.connectionTypeName === $scope.blocks.selected.srcConnection.connectionTypeName;
                                } else {
                                    return connection.direction === 'INPUT';
                                }
                            });
                            $scope.blocks.selected.dstConnection = $scope.blocks.dstConnections[0];
                        }
                        // populating the source blocks
                        if (!$scope.blocks.selected.srcBlock || $scope.blocks.selected.srcBlock.name === '') {
                            $scope.blocks.srcBlocks = blocks.filter((block: Models.IBlock) => {
                                return block.blockConnections.filter((connection: Models.IBlockConnections) => {
                                        if ($scope.blocks.selected.dstConnection) {
                                            return connection.direction === 'OUTPUT' &&
                                                connection.connectionTypeName === $scope.blocks.selected.dstConnection.connectionTypeName;
                                        } else {
                                            return connection.direction === 'OUTPUT';
                                        }
                                    }).length > 0;
                            });
                        }
                    } else {
                        $scope.blocks.dstConnections = [];
                    }
                }
            });

            $scope.$watch('blocks.selected.srcConnection', (newVal: Models.IBlockConnections, oldVal: Models.IBlockConnections) => {
                // a source connection has been selected
                if (newVal !== oldVal && newVal !== undefined) {
                    if ($scope.blocks.selected.dstBlock && $scope.blocks.selected.dstConnection &&
                        $scope.blocks.selected.dstConnection.connectionTypeName !== newVal.connectionTypeName) {
                        $scope.blocks.selected.dstBlock = Models.Block.Empty();
                        $scope.blocks.selected.srcConnection = undefined;
                        $scope.blocks.selected.dstConnection = undefined;
                    }
                }
            });

            $scope.$watch('blocks.selected.dstConnection', (newVal: Models.IBlockConnections, oldVal: Models.IBlockConnections) => {
                // a destination connection has been selected
                if (newVal !== oldVal && newVal !== undefined) {
                    if ($scope.blocks.selected.srcBlock && $scope.blocks.selected.srcConnection &&
                        $scope.blocks.selected.srcConnection.connectionTypeName !== newVal.connectionTypeName) {
                        $scope.blocks.selected.srcBlock = Models.Block.Empty();
                        $scope.blocks.selected.srcConnection = undefined;
                        $scope.blocks.selected.dstConnection = undefined;
                    }
                }
            });

            $scope.modalClose = (): void => {
                close(undefined);
            };

            $scope.modalSave = (): void => {
                if ($scope.blocks.selected.srcBlock && $scope.blocks.selected.srcConnection &&
                    $scope.blocks.selected.dstBlock && $scope.blocks.selected.dstConnection &&
                    $scope.blocks.selected.name && $scope.blocks.selected.name !== '') {
                    close({
                            name: $scope.blocks.selected.name,
                            srcConn: $scope.blocks.selected.srcConnection.id,
                            dstConn: $scope.blocks.selected.dstConnection.id,
                        });
                }
            };

            $scope.clear = (): void => {
                $scope.blocks = {
                    srcBlocks: [Models.Block.Empty()].concat(blocks),
                    srcConnections: [],
                    dstBlocks: [Models.Block.Empty()].concat(blocks),
                    dstConnections: [],
                    selected: {
                        srcBlock: Models.Block.Empty(),
                        srcConnection: undefined,
                        dstBlock: Models.Block.Empty(),
                        dstConnection: undefined,
                    },
                };
            };
        }

        private init(blocks: Models.Block[], $scope: IMultiBlockModalScope): Models.Block[] {
            blocks.map((block: Models.Block) => {
                block.blockConnections = block.blockConnections.filter((connection: Models.IBlockConnections) => {
                    return Common.Utils.isInArray(connection.connectionTypeName, Models.MultiBlock.allowedConnections);
                });
            });
            blocks = blocks.filter((block: Models.Block) => {
                return block.blockConnections.length > 0;
            });

            $scope.blocks = {
                srcBlocks: [Models.Block.Empty()].concat(blocks.filter((block: Models.Block) => {
                    return block.blockConnections.filter((connection: Models.IBlockConnections) => {
                            return connection.direction === 'OUTPUT';
                        }).length > 0;
                })),
                srcConnections: [],
                dstBlocks: [Models.Block.Empty()].concat(blocks.filter((block: Models.Block) => {
                    return block.blockConnections.filter((connection: Models.IBlockConnections) => {
                            return connection.direction === 'INPUT';
                        }).length > 0;
                })),
                dstConnections: [],
                selected: {
                    name: '',
                    srcBlock: undefined,
                    srcConnection: undefined,
                    dstBlock: undefined,
                    dstConnection: undefined,
                },
            };
            return blocks;
        }
    }
}